export class HttpError<T = unknown> extends Error {
  readonly status: number;
  readonly data: T;
  readonly response: { status: number; data: T };

  constructor(status: number, data: T, message?: string) {
    super(message ?? `Request failed with status ${status}`);
    this.name = 'HttpError';
    this.status = status;
    this.data = data;
    this.response = { status, data };
  }
}

export function isHttpError(error: unknown): error is HttpError {
  return error instanceof HttpError;
}

export type ErrorType<Error> = HttpError<Error>;
